import ResetPassword from "@/pages/account/auth/resetpassword";
import SetNewPassword from "@/pages/account/auth/setNewPassword";

import NewUser from "@/pages/newUser/classic";
import FreeCoachSignUp from "@/pages/newUser/free";
import PaidAssessmentSignUp from "@/pages/newUser/paidAssessments";


// import Test from "@/pages/test";

import BecomeTheChange from "@/pages/becomeTheChange";
import clientSignUp from "@/pages/client/signUp";
import assessments from "@/pages/assessments";
import assessmentResults from "@/pages/assessments/results";
import Logout from "@/pages/logout";

import { unauthRoute } from "./safeGuards";
import navLayout from "@/layouts/nav";

const routes = [
  {
    path: "/", component: navLayout, children: [
      {
        path: "/terms-of-service",
        name: "tos",
        component: () => {
          //   import('@/pages/account/tos/index.vue')
          return import(/* webpackChunkName: "tos" */ "@/pages/account/tos/index.vue");
        }
      },
      {
        name: "campaign",
        component: BecomeTheChange,
        path: "/create-the-change/:id/:slug"
      },
      {
        name: "assessmentResults",
        component: assessmentResults,
        path: "/assessments/results/:id"
      },
      {
        name: "assessments",
        component: assessments,
        path: "/assessments/:id/:slug",
        props: true
      },
      {
        name: "free-assessment",
        component: assessments,
        path: "/free-assessment",
        props: { id: process.env.VUE_APP_FREE_ASSESSMENT_ID }
      },
      unauthRoute("/free-assessment", assessments),
      unauthRoute("/reset-password", ResetPassword),
      unauthRoute("/reset-password/:token", SetNewPassword),

      // authRoute("/module/:id", Module, "module", true),
  
      unauthRoute("/invitation/:token", clientSignUp, "invitation"),
      // { path: "*", redirect: "/daily-exercise" },
      // authRoute("/test", Test, "test"),
      unauthRoute("/sign-up", clientSignUp, "clientSignUp"),
      unauthRoute("/sign-up/:id/:slug", clientSignUp, "clientSignUp"),
      { path: "/new-user/:offeringPromo", component: NewUser, name: "newUser" },
    ]
  },
  { path: "/coach-sign-up/free", component: FreeCoachSignUp, name: "FreeCoachSignUp", meta: {
    img: 'https://s3.amazonaws.com/prod-exercise-files/assets/Free+Plan.PNG'
  } },
  { path: "/coach-sign-up/professional", 
    component: PaidAssessmentSignUp, 
    name: "ProfessionalCoachSignUp", 
    meta: { 
      name: "Professional",
      package: `${ process.env.VUE_APP_PRO_OFFERING_ID }`, 
      img: 'https://s3.amazonaws.com/prod-exercise-files/assets/professional.png' 
    }
  },
  {
    path: "/coach-sign-up/enterprise",
    component: PaidAssessmentSignUp,
    name: "EnterpriseCoachSignUp",
    meta: {
      name: "Unlimited",
      package: `${ process.env.VUE_APP_ENTERPRISE_OFFERING_ID }`,
      img: "https://s3.amazonaws.com/prod-exercise-files/assets/Unlimited+Plan.PNG"
    }
  },
  {
    path: '/logout',
    component: Logout,
  },
  { path: "/index.html", redirect: "/"},
  { path: "*", redirect: "/" }
]

export default routes;
